





















































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  addActivityApi,
  editActivityApi,
  getActivityDetailApi,
  getActivityTypeListApi,
  getActivityPresetFormListApi,
} from "@/api/marketActivity";
import viewActivityDialog from "./viewActivityDialog.vue";
import marketStaffDialog from "./marketStaffDialog.vue";
import imageVideoUploader from "@/components/imageVideoUploader.vue";
import { dateFormat } from "@/utils/timeFormat";
import { __video_metadata_thumbnails__ } from "@/utils/video-metadata-thumbnails.iife.js";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";

@Component({
  name: "addActivity",
  components: {
    viewActivityDialog,
    marketStaffDialog,
    imageVideoUploader,
  },
})
export default class extends Vue {
  activity_id: number = 0; // 新增 / 编辑
  currentStep: string = "activityInfo";
  // 整体表单数据
  activityContentData: any = {
    type: "",
    title: "",
    stock: "",
    cover_list: {
      annex_type: 1,
    }, // 封面图片
    form_list: [], // 表单数据
    promotion: {
      title: "",
      quotation: "",
    }, // 引流数据
    appear_id: "",
    source_id: "",
    image_list: [],
    desc_list: [],
    descriptionValue: "", // 推广说明自定义文本
    radio: [],
    checkbox: [],
    is_pay: false, // 是否开启支付
    paid_amount: "", // 支付金额
    good_name: "", // 支付商品名
  };
  customDialogVisible: boolean = false; // 自定义表单弹窗
  currentCustom: string = ""; // 表单项类型
  currentTitle: string = ""; // 自定义表单弹窗名称
  editButtonText: boolean = false; // 自定义表单按钮文案
  eidtIndex: number = 0; // 编辑表单项下表
  // 暂存第二页的引流表单数据
  customFormData: any = {
    title: "",
    is_require: false,
    is_show: false,
    customRadio: [
      {
        label: "",
      },
      {
        label: "",
      },
    ], // 自定义单选
    customCheckbox: [
      {
        label: "",
      },
      {
        label: "",
      },
    ], // 自定义多选
  };
  viewImagePromotionUrl: string = "";
  descriptionInput: boolean = true;
  activityTypeList: any[] = [];
  copyDescList: any[] = []; // 判断非文本类型的长度
  sourceNode: any = ""; // 拖动的当前元素
  sourceList: any[] = [];
  market_staff_list: any[] = [];
  // 处理视频回传时的空白间隔
  imageVideoUploaderData: any = {
    receiveResourceCover: false,
    receiveResourcePromotion: false,
  };
  blurStatus: boolean = true; // 控制支付金额文本框输入失焦
  percent: number = 0; // 上传进度，控制资源上传
  uploading: boolean = false; // 控制资源获取
  currentImageScale: boolean = true; // 图片比例
  currentVideoScale: boolean = true; // 视频比例
  studentAppearLabelList: any[] = [];
  // 过去日期不可选
  effectiveDate: any = {
    disabledDate(date: any) {
      return date.getTime() < Date.now() - 8.64e7;
    },
  };
  @Watch("activityContentData.time")
  onChangeValue(newVal: any, oldVal: any) {
    let nowDate = Date.now();
    if (newVal) {
      // 区分新增和编辑的日期数据
      if (typeof newVal[0] === "object") {
        if (newVal[0].getTime() === newVal[1].getTime()) {
          this.$message({
            type: "error",
            message: "活动开始时间不能和活动结束时间一致，请重新选择",
          });
          return false;
        }
        let targetDate = newVal[0].getTime();
        if (targetDate < nowDate) {
          this.$message({
            type: "error",
            message: "活动时间不能早于当前时间，请重新选择",
          });
        }
      }
    }
  }
  created() {
    this.activity_id = Number(this.$route.query.activity_id);
    this.getActivityTypeListList("");
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    if (this.activity_id) {
      getActivityDetailApi({ activity_id: this.activity_id }).then(
        (res: any) => {
          this.market_staff_list = res.data.market_staff_list;
          // 表单回填
          res.data.form_list.forEach((item: any, index: any) => {
            item.sort = index + 1;
            item.is_show = item.is_show === 1 ? true : false;
            item.is_require = item.is_require === 1 ? true : false;
            if (item.preset_form_id === 1) {
              item.is_show = true;
            }
            if (item.preset_form_id === 4) {
              item.is_show = true;
            }
          });
          this.activityContentData = {
            type: res.data.type.type_id,
            title: res.data.title,
            time: [
              dateFormat("YYYY-mm-dd HH:MM:SS", res.data.start_time * 1000),
              dateFormat("YYYY-mm-dd HH:MM:SS", res.data.end_time * 1000),
            ],
            stock: res.data.stock,
            cover_list: {
              annex_content:
                res.data.cover_list.length > 0
                  ? res.data.cover_list[0].annex_content
                  : "",
              annex_type:
                res.data.cover_list.length > 0
                  ? res.data.cover_list[0].annex_type
                  : "",
            },
            form_list: res.data.form_list,
            appear_id: res.data.appear_id,
            source_id: res.data.source_id,
            is_promotion: res.data.is_promotion === 1 ? true : false,
            promotion: res.data.promotion.promotion,
            image_list: res.data.promotion.image_list,
            desc_list: res.data.promotion.desc_list,
            radio: [],
            checkbox: [],
            descriptionValue: "",
            viewList: res.data.form_list,
            is_desc: false,
            is_pay: res.data.is_pay === 1 ? true : false,
            paid_amount: res.data.activity_goods.paid_amount,
            good_name: res.data.activity_goods.name,
          };
          // 如果 is_promotion === 2 则 promotion 字段为空，需要将 title 和 quotation 单独初始化
          if (res.data.is_promotion === 2) {
            this.activityContentData.promotion = {
              title: "",
              quotation: "",
            };
          }
          if (res.data.promotion) {
            res.data.promotion.desc_list.forEach((item: any) => {
              if (item.annex_type === 3) {
                // 活动说明文本回填
                this.activityContentData.descriptionValue = item.annex_content;
                this.descriptionInput = false;
              }
            });
            // 过滤出不带 3 类型的数据，用来展示
            this.copyDescList = res.data.promotion.desc_list.filter(
              (item: any) => {
                if (item.annex_type === 1) {
                  this.viewImagePromotionUrl = item.annex_content;
                }
                if (item.annex_type !== 3) {
                  return item;
                }
              }
            );
            if (res.data.promotion.desc_list.length > 0) {
              this.activityContentData.is_desc = true;
            }
          }

          this.getSourceTypeKVListApi();
        }
      );
    } else {
      this.getActivityPresetFormListApiFn();
    }
  }
  // 获取表单预设数据
  getActivityPresetFormListApiFn() {
    getActivityPresetFormListApi().then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any, index: any) => {
          item.sort = index + 1;
          // 1 和 4 必显必填
          if (item.preset_form_id === 1) {
            item.is_show = true;
          } else if (item.preset_form_id === 4) {
            item.is_show = true;
          } else {
            item.is_show = false;
          }
          // 小于 5 的都必填
          if (item.preset_form_id <= 5) {
            item.is_require = true;
          } else {
            item.is_require = false;
          }
        });
        this.activityContentData.form_list = res.data.list;
      }
    });
  }

  solveActivityContentDataInfo() {
    if (this.activityContentData.viewList) {
      this.activityContentData.form_list = this.activityContentData.viewList;
    }
    let params: any = {
      cover_list: [],
      form_list: [],
      promotion: {
        image_list: [],
        desc_list: [],
      },
    };
    let errorMessage: string = "";
    if (this.activityContentData.type) {
      params.type_id = this.activityContentData.type;
    } else {
      errorMessage = "请选择活动类型";
      return { params, errorMessage };
    }
    if (this.activityContentData.title) {
      params.title = this.activityContentData.title;
    } else {
      errorMessage = "请填写活动名称";
      return { params, errorMessage };
    }
    if (this.activityContentData.time[0] && this.activityContentData.time[1]) {
      if (this.activity_id) {
        params.start_time =
          new Date(this.activityContentData.time[0]).valueOf() / 1000;
        params.end_time =
          new Date(this.activityContentData.time[1]).valueOf() / 1000;
      } else {
        let nowDate = Date.now();
        let targetDate = this.activityContentData.time[0].getTime();
        params.start_time = this.activityContentData.time[0].valueOf() / 1000;
        params.end_time = this.activityContentData.time[1].valueOf() / 1000;
        if (this.currentStep === "activityInfo") {
          if (
            this.activityContentData.time[0].getTime() ===
            this.activityContentData.time[1].getTime()
          ) {
            errorMessage = "活动开始时间不能和活动结束时间一致，请重新选择";
          }
          if (targetDate < nowDate) {
            errorMessage = "活动时间不能早于当前时间，请重新选择";
          }
        }
      }
    } else {
      errorMessage = "请选择活动时间";
      return { params, errorMessage };
    }

    if (this.activityContentData.stock) {
      if (String(this.activityContentData.stock).includes(".")) {
        errorMessage = "活动库存数必须是整数";
      }
      if (this.activityContentData.stock < 1) {
        errorMessage = "活动库存数量要大于或等于1";
      }
      params.stock = Number(this.activityContentData.stock);
    } else {
      errorMessage = "请选择活动库存";
      return { params, errorMessage };
    }
    if (this.activityContentData.appear_id) {
      params.appear_id = this.activityContentData.appear_id;
    } else {
      errorMessage = "请选择出现方式";
      return { params, errorMessage };
    }
    if (this.activityContentData.source_id) {
      params.source_id = this.activityContentData.source_id;
    } else {
      errorMessage = "请选择来源渠道";
      return { params, errorMessage };
    }

    if (this.activityContentData.cover_list.annex_content) {
      params.cover_list.push({
        annex_content: this.delPreDomain(
          this.activityContentData.cover_list.annex_content
        ),
        annex_type: this.activityContentData.cover_list.annex_type,
        sort: 1,
      });
    } else {
      // 活动封面为选填
      this.activityContentData.cover_list = {
        annex_type: 1,
      };
      // errorMessage = "请选择活动封面";
      // return { params, errorMessage };
    }
    // 表单数据
    if (this.activityContentData.form_list) {
      params.form_list = this.activityContentData.form_list.map((item: any) => {
        if (item.preset_form_id > 5 && item.type !== 1) {
          item.default_value = JSON.stringify(
            JSON.parse(item.default_value).map((it: any) => {
              if (typeof it !== "object") {
                return it;
              } else {
                return it.label;
              }
            })
          );
        }
        return item;
      });
    }
    // 是否开启支付
    params.is_pay = this.activityContentData.is_pay === true ? 1 : 2;
    if (
      this.currentStep === "promotionSetting" &&
      this.activityContentData.is_pay
    ) {
      if (Number(this.activityContentData.paid_amount) > 0) {
        params.paid_amount = String(this.activityContentData.paid_amount);
      } else {
        errorMessage = "请正确填写支付金额";
        return { params, errorMessage };
      }

      if (this.activityContentData.good_name) {
        params.good_name = this.activityContentData.good_name;
      } else {
        errorMessage = "请输入支付商品名称";
        return { params, errorMessage };
      }
    }
    // 是否开启引流
    params.is_promotion =
      this.activityContentData.is_promotion === true ? 1 : 2;
    if (
      this.currentStep === "promotionSetting" &&
      this.activityContentData.is_promotion
    ) {
      // 引流标题
      if (this.activityContentData.promotion.title) {
        params.promotion.title = this.activityContentData.promotion.title;
      } else {
        errorMessage = "请填写引流标题";
        return { params, errorMessage };
      }
      // 引流图片
      if (this.activityContentData.image_list.length > 0) {
        this.activityContentData.image_list.forEach((item: any) => {
          params.promotion.image_list.push({
            annex_content: this.delPreDomain(item.annex_content),
            annex_type: 1,
            sort: params.promotion.image_list.length,
          });
        });
      } else {
        errorMessage = "引流图片不能为空";
        return { params, errorMessage };
      }
    }
    // 引流语指引语
    if (this.activityContentData.promotion.quotation) {
      params.promotion.quotation = this.activityContentData.promotion.quotation;
    }
    // 推广说明 - 图片或视频
    if (this.activityContentData.desc_list.length > 0) {
      this.activityContentData.desc_list.forEach((item: any) => {
        params.promotion.desc_list.push({
          annex_content: this.delPreDomain(item.annex_content),
          annex_type: item.annex_type,
          sort: params.promotion.desc_list.length,
        });
      });
    }
    // 推广说明 - 文本
    if (this.activityContentData.descriptionValue) {
      // 数组如果有数据，判断内部是否包含 3 类型的数据，有的话直接改
      let ret = params.promotion.desc_list.some((item: any) => {
        if (item.annex_type === 3) {
          item.annex_content = this.activityContentData.descriptionValue;
          return true; // 返回 true 来终止遍历
        }
      });
      // 没有 3 类型的数据，就新增
      if (!ret) {
        params.promotion.desc_list.push({
          annex_content: this.activityContentData.descriptionValue,
          annex_type: 3,
          sort: params.promotion.desc_list.length,
        });
      }
    }
    // 状态字段给个默认值
    params.status = 1;
    // 市场顾问
    if (this.market_staff_list.length > 0) {
      params.market_staff_ids = this.market_staff_list.map((item: any) => {
        return item.staff_id;
      });
    } else {
      errorMessage = "请添加市场顾问";
      return { params, errorMessage };
    }
    return { params, errorMessage };
  }

  handleNextStep() {
    let data: any = this.solveActivityContentDataInfo();
    if (this.percent > 0 && this.percent < 100) {
      this.$message({
        type: "error",
        message: "资源上传中",
      });
      return false;
    }
    if (this.uploading) {
      this.$message({
        type: "error",
        message: "资源获取中",
      });
      return false;
    }
    if (data.errorMessage) {
      this.$message({
        message: data.errorMessage,
        type: "error",
      });
      return false;
    }
    this.currentStep = "promotionSetting";
  }

  handlePreStep() {
    let data: any = this.solveActivityContentDataInfo();
    if (this.percent > 0 && this.percent < 100) {
      this.$message({
        type: "error",
        message: "资源上传中",
      });
      return false;
    }
    if (this.uploading) {
      this.$message({
        type: "error",
        message: "资源获取中",
      });
      return false;
    }
    if (data.errorMessage) {
      this.$message({
        message: data.errorMessage,
        type: "error",
      });
      return false;
    }
    this.currentStep = "activityInfo";
  }
  // 保存
  handleSave() {
    let data: any = this.solveActivityContentDataInfo();
    if (this.percent > 0 && this.percent < 100) {
      this.$message({
        type: "error",
        message: "资源上传中",
      });
      return false;
    }
    if (this.uploading) {
      this.$message({
        type: "error",
        message: "资源获取中",
      });
      return false;
    }
    if (data.errorMessage) {
      this.$message({
        type: "error",
        message: data.errorMessage,
      });
      return false;
    }
    data.params.form_list.forEach((item: any) => {
      item.is_show = item.is_show === true ? 1 : 2;
      if (item.preset_form_id <= 5) {
        item.is_require = 1;
      } else {
        item.is_require = item.is_require === true ? 1 : 2;
      }
    });
    if (this.activity_id) {
      data.params.activity_id = this.activity_id;
      editActivityApi(data.params).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            message: "活动修改成功",
            type: "success",
          });
          setTimeout(() => {
            this.handleBack();
          }, 500);
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
          this.getActivityPresetFormListApiFn();
        }
      });
    } else {
      addActivityApi(data.params).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            message: "活动添加成功",
            type: "success",
          });
          setTimeout(() => {
            this.handleBack();
          }, 500);
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
          this.getActivityPresetFormListApiFn();
        }
      });
    }
  }
  getActivityTypeListList(v?: any) {
    getActivityTypeListApi({ page: 1, page_size: 100, title: v || "" }).then(
      (res: any) => {
        if (res.error_code === 0) {
          this.activityTypeList = res.data.list;
        }
      }
    );
  }
  handleStockChange(val: any) {
    if (val < 1) {
      this.$message({
        type: "error",
        message: "活动库存数量要大于或等于1",
      });
    }
    if (val.includes(".")) {
      this.$message({
        message: "活动库存必须为整数",
        type: "error",
      });
    }
  }
  // 模糊搜索 - 活动类型
  handleSearchType(v: any) {
    if (v.length > 18) {
      v = v.slice(0, 18);
    }
    this.getActivityTypeListList(v);
    // this.activityContentData.type = v;
  }
  getSourceTypeKVListApi() {
    if (!this.activityContentData.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({
      appear_id: this.activityContentData.appear_id,
      status: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
  }
  // 活动类型列表下拉
  handleTypeVisible(...rest: any) {
    if (rest[0]) {
      this.getActivityTypeListList();
    }
  }
  // 来源渠道列表下拉
  handleSourceVisible(evt: any) {
    if (evt) {
      if (!this.activityContentData.appear_id) {
        this.sourceList = [];
        return this.$message({
          message: "请选择出现方式",
          type: "warning",
        });
      }
    }
  }
  handlePaidAmountInput() {
    this.activityContentData.paid_amount = this.handleInput(
      this.activityContentData.paid_amount
    );
  }
  // 输入逻辑控制
  handleInput(val: any) {
    let n = String(val);
    if (n.includes("-")) {
      this.$message({
        message: "不能为负数",
        type: "error",
      });
      // let i = n.indexOf("-");
      // n = n.slice(i + 1);
    }
    let l = n.split(".");
    // 如果有小数，并且小数的位数大于2，将2位之后的数直接截掉
    if (l.length > 1 && l[1].length > 2) {
      l[1] = l[1].slice(0, 2);
      this.$message({
        message: "最多输入两位小数",
        type: "error",
      });
    }
    return l.join(".");
  }
  // 获焦暂停计算
  handleFocus() {
    this.blurStatus = false;
  }
  // 失焦计算
  handleBlur() {
    this.blurStatus = true;
    // 如果为空，失焦时，阻止非 0 提示
    if (this.activityContentData.paid_amount === "") {
      return false;
    }
    if (Number(this.activityContentData.paid_amount) === 0) {
      this.$message({
        type: "error",
        message: "支付金额不能为0",
      });
    }
  }
  // 如果重置了支付设置开关，则对应的支付数据全部清空
  handleIsPay(evt: any) {
    if (!evt) {
      this.activityContentData.paid_amount = "";
      this.activityContentData.good_name = "";
    }
  }

  // 如果重置了引流页开关，则对应的引流页数据全部清空
  handleIsPromotion(evt: any) {
    if (!evt) {
      this.activityContentData.promotion.quotation = "";
      this.activityContentData.promotion.title = "";
      this.activityContentData.image_list = [];
    }
  }
  // 推广说明开关
  handleIsDesc(evt: any) {
    this.activityContentData.is_desc = evt;
    if (!evt) {
      this.activityContentData.desc_list = [];
      this.descriptionInput = true;
      this.activityContentData.descriptionValue = "";
      this.copyDescList = [];
    }
  }
  handlePreviewImageCover() {
    const elImageCover: any = document.querySelector("#elImageCover");
    if (elImageCover) {
      elImageCover.click();
    }
  }
  handlePreviewImagePromotion(item: any) {
    this.viewImagePromotionUrl = item.annex_content;
    const elImagePromotion: any = document.querySelector("#elImagePromotion");
    if (elImagePromotion) {
      elImagePromotion.click();
    }
  }
  // 监听活动上传进度
  handleListenPercent(evt: any) {
    this.percent = evt;
  }
  handleUploading(evt: any) {
    this.uploading = evt;
  }
  // 拿到 file 对象，检测图片和视频的宽高是否符合限制，val 区分上传的类型
  mediaCheck(e: any, val: any) {
    // console.log(e, val);
    // 重新初始化比例数据
    this.currentVideoScale = true;
    this.currentImageScale = true;
    let type = e.file.type;
    if (type.includes("image")) {
      this.compressImage(
        e.file,
        0.5,
        (blob: any) => {
          const url = URL.createObjectURL(blob);
          const img = document.createElement("img");
          img.src = url;
          // document.body.appendChild(img);
        },
        val
      );
    }
    if (type.includes("video")) {
      __video_metadata_thumbnails__
        .getMetadata(e.file)
        .then((metadata: any) => {
          // console.log("素材信息", metadata);
          let scale = (metadata.width / metadata.height).toFixed(3);
          let res = this.handleWatchScale({ scale });
          if (!res) {
            if (val === "cover") {
              this.activityContentData.cover_list.annex_content = "";
            }
            this.$message({
              message: "请上传 16:9 比例的视频",
              type: "error",
            });
            this.currentVideoScale = false;
          } else {
            this.currentVideoScale = true;
          }
        });
    }
    return true;
  }
  // 压缩图片，接收一个文件对象、压缩比例和回调函数作为参数
  compressImage(file: any, quality: any, callback: any, val: any) {
    const reader = new FileReader(); // 使用 FileReader 对象读取文件数据
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image(); // 创建一个 Image 对象，并将图片绘制到 Canvas 上
      img.src = (event.target as any).result;
      img.onload = () => {
        let canvas: any = document.createElement("canvas");
        let ctx: any = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        let scale = (canvas.width / canvas.height).toFixed(3);
        let res = this.handleWatchScale({ scale });
        // 每个类型图片的大小和提示语都不相同
        if (val === "cover") {
          if (canvas.width < 750 || canvas.height < 422) {
            this.activityContentData.cover_list.annex_content = "";
            this.$message({
              message: "请上传大于 750 * 422 尺寸并且为 16:9 比例的图片",
              type: "error",
            });
            this.currentImageScale = false;
            return false;
          } else {
            this.currentImageScale = true;
          }
          if (!res) {
            this.activityContentData.cover_list.annex_content = "";
            this.currentImageScale = false;
            this.$message({
              type: "error",
              message: `请上传大于 750 * 422 尺寸并且为 16:9 比例的图片`,
            });
            return false;
          } else {
            this.currentImageScale = true;
          }
        }
        // 每个类型图片的大小和提示语都不相同
        if (val === "image") {
          if (canvas.width !== 650 && canvas.height !== 650) {
            this.$message({
              message: "请上传 650 * 650 尺寸的图片",
              type: "error",
            });
            this.currentImageScale = false;
            return false;
          } else {
            this.currentImageScale = true;
          }
        }
        // 每个类型图片的大小和提示语都不相同
        if (val === "desc") {
          if (canvas.width < 750) {
            this.$message({
              message: "请上传宽度大于等于 750尺寸 的图片",
              type: "error",
            });
            this.currentImageScale = false;
            return false;
          } else {
            this.currentImageScale = true;
          }
        }

        ctx.drawImage(img, 0, 0, img.width, img.height);
        //然后使用 toBlob() 方法将 Canvas 上的图像数据转换成 Blob 对象
        canvas.toBlob(
          (blob: any) => {
            callback(blob); // 回调函数处理压缩后的数据。
          },
          file.type,
          quality
        );
      };
    };
  }
  // 图片或视频比例
  handleWatchScale(data: any) {
    if (!data.scale.startsWith("1.77")) {
      return false;
    } else {
      return true;
    }
  }
  // 满足条件，开始正式上传
  handleSelected(e: any) {
    if (!this.currentImageScale) return; // 图片大小不对
    if (!this.currentVideoScale) return; // 视频比例不对
    e.start();
  }
  // 封面图片或视频回调
  handleImageVideoUploader(data: any) {
    // 处理视频回传时的空白间隔
    this.imageVideoUploaderData.receiveResourceCover =
      !this.imageVideoUploaderData.receiveResourceCover;
    if (data.type === 1) {
      this.activityContentData.cover_list.annex_content = data.url;
      this.activityContentData.cover_list.annex_type = data.type;
    } else if (data.type === 2) {
      this.activityContentData.cover_list.annex_content = data.url;
      this.activityContentData.cover_list.annex_type = data.type;
    }
    this.$message({
      message: "上传成功",
      type: "success",
    });
    this.handleResetUploadStatus();
  }

  handleImageVideoClear() {
    this.activityContentData.cover_list.annex_type = 1;
    this.$message({
      type: "success",
      message: "删除成功",
    });
    this.handleResetUploadStatus();
  }
  // 引流、推广图片或视频回调
  handleImageUploader(...rest: any) {
    this.imageVideoUploaderData.receiveResourcePromotion =
      !this.imageVideoUploaderData.receiveResourcePromotion;
    if (rest[1] === "image_list") {
      this.viewImagePromotionUrl = rest[0].url;
      this.activityContentData.image_list.push({
        annex_content: rest[0].url,
        annex_type: 1,
        sort: this.activityContentData.image_list.length + 1,
      });
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.handleResetUploadStatus();
    }
    if (rest[1] === "desc_list") {
      if (rest[0].type === 1) {
        this.handleDescList(rest[0]);
      } else if (rest[0].type === 2) {
        this.handleDescList(rest[0]);
      }
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.handleResetUploadStatus();
    }
  }
  // 处理推广说明的资源
  handleDescList(data: any) {
    this.activityContentData.desc_list.push({
      annex_content: data.url,
      annex_type: data.type,
      sort: this.activityContentData.desc_list.length + 1,
    });
    this.activityContentData.promotion.desc_list =
      this.activityContentData.desc_list;
    // 过滤出不带 3 类型的数据
    this.copyDescList = this.activityContentData.desc_list.filter(
      (item: any) => {
        if (item.annex_type === 1) {
          this.viewImagePromotionUrl = item.annex_content;
        }
        if (item.annex_type !== 3) {
          return item;
        }
      }
    );
  }
  handleImageClear(...rest: any) {
    if (rest[1] === "image_list") {
      this.activityContentData.image_list.splice(rest[0], 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    }
    if (rest[1] === "desc_list") {
      this.activityContentData.desc_list.splice(rest[0], 1);
      this.copyDescList.splice(rest[0], 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    }
    this.handleResetUploadStatus();
  }
  // 重置资源上传数据，（上传成功、删除成功时）
  handleResetUploadStatus() {
    this.percent = 0;
    this.uploading = false;
  }

  handleViewForm() {
    if (!this.activityContentData.viewList) {
      this.activityContentData.viewList = this.activityContentData.form_list;
    }
  }
  handleCustomDialog(v: any) {
    this.customDialogVisible = true;
    this.editButtonText = false;
    this.updateCustomDialogType(v);
  }
  updateCustomDialogType(v: any) {
    this.currentCustom = v;
    if (v === "input") {
      this.currentTitle = "文本框";
    }
    if (v === "radio") {
      this.currentTitle = "单选框";
    }
    if (v === "checkbox") {
      this.currentTitle = "多选框";
    }
  }
  handleAddDescriptionInput() {
    this.descriptionInput = false;
  }
  // 添加单选 / 多选项
  addItem() {
    if (this.currentCustom === "radio") {
      this.customFormData.customRadio.push({
        label: "",
      });
    }
    if (this.currentCustom === "checkbox") {
      this.customFormData.customCheckbox.push({
        label: "",
      });
    }
    this.$message({
      message: "添加成功",
      type: "success",
    });
  }
  // 删除单选 / 多选项
  delItem(item: any) {
    if (this.currentCustom === "radio") {
      if (this.customFormData.customRadio.length <= 2) {
        return this.$message({
          message: "删除失败，至少有两个选项",
          type: "warning",
        });
      }
      let index = this.customFormData.customRadio.indexOf(item);
      if (index === 0 || index === 1) {
        return this.$message({
          message: "第一项和第二项为默认选项,不能被删除",
          type: "warning",
        });
      }
      this.customFormData.customRadio.splice(index, 1);
    }
    if (this.currentCustom === "checkbox") {
      if (this.customFormData.customCheckbox.length <= 2) {
        return this.$message({
          message: "删除失败，至少有两个选项",
          type: "warning",
        });
      }
      let index = this.customFormData.customCheckbox.indexOf(item);
      if (index === 0 || index === 1) {
        return this.$message({
          message: "第一项和第二项为默认选项,不能被删除",
          type: "warning",
        });
      }
      this.customFormData.customCheckbox.splice(index, 1);
    }
  }
  // 提交单选 / 多选项
  addSubmit() {
    // this.customDialogVisible = false;
    if (!this.customFormData.title) {
      this.$message({
        type: "warning",
        message: "请输入标题",
      });
      return false;
    }
    let errorMessage = false;
    this.activityContentData.form_list.map((item: any, index: any) => {
      if (item.title === this.customFormData.title) {
        // 如果编辑的是本身，则不用弹窗提示
        if (index !== this.eidtIndex) {
          this.$message({
            type: "warning",
            message: "该表单项已存在，不能重复添加",
          });
          errorMessage = true;
        }
      }
    });
    if (errorMessage) {
      return false;
    }
    // false 为新增
    if (!this.editButtonText) {
      if (this.currentCustom === "input") {
        this.activityContentData.form_list.push({
          preset_form_id: this.activityContentData.form_list.length + 1,
          type: 1,
          title: this.customFormData.title,
          default_value: "",
          is_require: this.customFormData.is_require,
          is_show: this.customFormData.is_show,
          sort: this.activityContentData.form_list.length,
        });
      }
      if (this.currentCustom === "radio") {
        let res = this.handleIsEmptyItem("radio");
        if (!res) return;
        // 用于页面数据展示
        this.activityContentData.radio.push({
          title: this.customFormData.title,
          is_require: this.customFormData.is_require,
          is_show: this.customFormData.is_show,
          customRadio: this.customFormData.customRadio,
        });
        // 用于表单数据提交
        this.activityContentData.form_list.push({
          preset_form_id: this.activityContentData.form_list.length + 1,
          type: 2,
          title: this.customFormData.title,
          default_value: JSON.stringify(this.customFormData.customRadio),
          is_require: this.customFormData.is_require,
          is_show: this.customFormData.is_show,
          sort: this.activityContentData.form_list.length + 1,
        });
      }
      if (this.currentCustom === "checkbox") {
        let res = this.handleIsEmptyItem("checkbox");
        if (!res) return;
        this.activityContentData.checkbox.push({
          title: this.customFormData.title,
          is_require: this.customFormData.is_require,
          is_show: this.customFormData.is_show,
          customCheckbox: this.customFormData.customCheckbox,
        });
        this.activityContentData.form_list.push({
          preset_form_id: this.activityContentData.form_list.length + 1,
          type: 3,
          title: this.customFormData.title,
          default_value: JSON.stringify(this.customFormData.customCheckbox),
          is_require: this.customFormData.is_require,
          is_show: this.customFormData.is_show,
          sort: this.activityContentData.form_list.length + 1,
        });
      }
      this.$message({
        type: "success",
        message: "添加成功",
      });
    } else {
      this.activityContentData.form_list[this.eidtIndex].title =
        this.customFormData.title;
      this.activityContentData.form_list[this.eidtIndex].is_require =
        this.customFormData.is_require;
      if (this.currentTitle === "单选框") {
        let res = this.handleIsEmptyItem("radio");
        if (!res) return;
        // 编辑后的数据赋值
        this.activityContentData.form_list[this.eidtIndex].default_value =
          JSON.stringify(this.customFormData.customRadio);
      }
      if (this.currentTitle === "多选框") {
        let res = this.handleIsEmptyItem("checkbox");
        if (!res) return;
        // 编辑后的数据赋值
        this.activityContentData.form_list[this.eidtIndex].default_value =
          JSON.stringify(this.customFormData.customCheckbox);
      }
      this.$message({
        type: "success",
        message: "编辑成功",
      });
    }
    this.handleCloseCustomDialog();
  }
  // 编辑表单项
  editFormItem(item: any) {
    // 只能编辑自定义的表单项
    if (item.preset_form_id > 5) {
      this.editButtonText = true;
      this.customDialogVisible = true;
      this.customFormData.title = item.title;
      this.customFormData.is_require = item.is_require;
      // this.customFormData.is_show = item.is_show;
      // 找到单击表单项的位置
      this.eidtIndex = this.activityContentData.form_list.indexOf(item);
      if (item.type === 1) {
        this.updateCustomDialogType("input");
      }
      if (item.type === 2) {
        this.updateCustomDialogType("radio");
        // 回填数据
        this.customFormData.customRadio = JSON.parse(
          this.activityContentData.form_list[this.eidtIndex].default_value
        ).map((item: any) => {
          if (typeof item !== "object") {
            return {
              label: item,
            };
          } else {
            return {
              label: item.label,
            };
          }
        });
      }
      if (item.type === 3) {
        this.updateCustomDialogType("checkbox");
        // 回填数据
        this.customFormData.customCheckbox = JSON.parse(
          this.activityContentData.form_list[this.eidtIndex].default_value
        ).map((item: any) => {
          if (typeof item !== "object") {
            return {
              label: item,
            };
          } else {
            return {
              label: item.label,
            };
          }
        });
      }
    }
  }
  // 判断是否有空的表单项
  handleIsEmptyItem(evt: any) {
    if (evt === "radio") {
      let res = this.customFormData.customRadio.some((item: any) => {
        if (item.label === "") {
          return true;
        }
      });
      if (res) {
        this.$message({
          message: "请补全选项内容",
          type: "error",
        });
        return false;
      } else {
        for (let i = 0; i < this.customFormData.customRadio.length - 1; i++) {
          for (
            let j = i + 1;
            j <= this.customFormData.customRadio.length - 1;
            j++
          ) {
            if (
              this.customFormData.customRadio[i].label ===
              this.customFormData.customRadio[j].label
            ) {
              this.$message({
                message: "有重复的选项内容",
                type: "error",
              });
              return false;
            }
          }
        }
        return true;
      }
    } else if (evt === "checkbox") {
      let res = this.customFormData.customCheckbox.some((item: any) => {
        if (item.label === "") {
          return true;
        }
      });
      if (res) {
        this.$message({
          message: "请补全选项内容",
          type: "error",
        });
        return false;
      } else {
        for (
          let i = 0;
          i < this.customFormData.customCheckbox.length - 1;
          i++
        ) {
          for (
            let j = i + 1;
            j <= this.customFormData.customCheckbox.length - 1;
            j++
          ) {
            if (
              this.customFormData.customCheckbox[i].label ===
              this.customFormData.customCheckbox[j].label
            ) {
              this.$message({
                message: "有重复的选项内容",
                type: "error",
              });
              return false;
            }
          }
        }
        return true;
      }
    }
  }
  // 取消
  cancelSubmit() {
    this.handleCloseCustomDialog();
  }
  handleCloseCustomDialog() {
    this.customDialogVisible = false;
    // 重新初始化
    setTimeout(() => {
      this.customFormData = {
        title: "",
        is_require: false,
        is_show: false,
        customRadio: [
          {
            label: "",
          },
          {
            label: "",
          },
        ],
        customCheckbox: [
          {
            label: "",
          },
          {
            label: "",
          },
        ],
      };
    }, 100);
  }
  // 删除市场人员
  delMarket(item: any) {
    this.$confirm(
      `"确定对${item.name}市场顾问在该活动删除吗？"`,
      `"删除${item.name}市场顾问"`,
      {
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "mwow-button-filled success",
        cancelButtonClass: "mwow-button-filled",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        let index = this.market_staff_list.indexOf(item);
        this.market_staff_list.splice(index, 1);
        this.$message({
          message: "删除成功",
          type: "success",
        });
      })
      .catch(() => {});
  }
  // 市场数据回传
  handleMarketList(v: any) {
    // console.log(v);
    this.market_staff_list = v;
  }

  // 监听拖动开始（事件委托）
  handleDragstart(e: any) {
    this.sourceNode = e.target;
    e.dataTransfer.effectAllowed = "move";
    // console.log("拖动元素", e.target);
  }
  // 监听拖动完成（事件委托）
  handleDragover(e: any) {
    e.preventDefault();
  }
  // 监听拖动进入（事件委托）
  handleDragenter(e: any) {
    e.preventDefault();
    if (this.sourceNode.className !== "li") {
      return;
    }
    let list: any = document.querySelector(".ul");
    let tip: any = document.querySelector(".ul .title .tip");
    // 排除父元素和自身的情况
    if (e.target === list || e.target.parentNode === this.sourceNode || tip) {
      return;
    }
    if (e.target.parentNode === list) {
      return;
    }
    // 转换为数组，拿到对应元素的下标
    let children = Array.from(list.children);
    let sourceIndex = children.indexOf(this.sourceNode);
    let targetIndex = children.indexOf(e.target.parentNode);
    if (targetIndex === -1) return false;
    // 往下拖动，将当前元素插入到目标元素的下一个位置,（注意 title dom节点）
    if (sourceIndex < targetIndex) {
      list.insertBefore(
        this.sourceNode,
        e.target.parentNode.className === "li"
          ? e.target.parentNode.nextElementSibling
          : e.target.parentNode.parentNode.nextElementSibling
      );
    }
    // 往上拖动，将当前元素插入到目标元素的位置
    if (sourceIndex > targetIndex) {
      try {
        list.insertBefore(
          this.sourceNode,
          e.target.parentNode.className === "li"
            ? e.target.parentNode
            : e.target.parentNode.parentNode
        );
      } catch (err) {
        err;
      }
    }
    let preset_form_id = document.querySelectorAll(".ul .li .preset_form_id");
    let arrId: any[] = []; // 记录拖拽位置后的 preset_form_id
    preset_form_id.forEach((item: any) => {
      arrId.push(Number(item.innerHTML - 1));
    });

    let copy: any[] = [];
    // 编辑回填排序
    if (this.activity_id) {
      arrId.forEach((item: any, index: any) => {
        for (let i = 0; i < this.activityContentData.form_list.length; i++) {
          if (
            item + 1 ===
            this.activityContentData.form_list[i].preset_form_id
          ) {
            copy[index] = this.activityContentData.form_list[i];
            copy[index].sort = index + 1; // 将 copy 的 sort 字段重新排序
            continue;
          }
        }
      });
    } else {
      // 新增排序
      arrId.forEach((item: any, index: any) => {
        copy[index] = this.activityContentData.form_list[item];
        // 直接修改原数组的 sort
        this.activityContentData.form_list[item].sort = index + 1;
      });
    }
    this.activityContentData.viewList = copy;

    // this.activityContentData.viewList.forEach((item: any) => {
    //   console.log(item.title, item.sort);
    // });
    // console.log("排序后的数据", this.activityContentData.viewList);
  }
  // 去域名前缀
  delPreDomain(url: any) {
    if (url) {
      let ret = url.split("/");
      return ret[ret.length - 1];
    }
  }
  handleBack() {
    this.$router.push({
      name: "activityManagement",
    });
  }
}
